import React from "react";

const reviews = [
  {
    name: "Aryan Sharma",
    date: "2 days ago",
    course: "Discover Yourself",
    avatar: "https://i.pravatar.cc/150?u=aryan",
    rating: 5,
    comment:
      "The DYS course changed how I view my daily habits. The connection between science and spirituality was explained so logically.",
    verified: true,
  },
  {
    name: "Sneha Kapoor",
    date: "1 week ago",
    course: "Self Manager",
    avatar: "https://i.pravatar.cc/150?u=sneha",
    rating: 5,
    comment:
      "I finally found a practical way to manage stress. The instructors are incredibly patient.",
    verified: true,
  },
  {
    name: "Rohan Varma",
    date: "Mar 2024",
    course: "Bhagwad Gita",
    avatar: "https://i.pravatar.cc/150?u=rohan",
    rating: 5,
    comment:
      "Highly recommended for anyone feeling lost in their career. It’s not just a course; it’s a life manual.",
    verified: true,
  },
  {
    name: "Ishita Das",
    date: "Feb 2024",
    course: "Positive Thinker",
    avatar: "https://i.pravatar.cc/150?u=ishita",
    rating: 4,
    comment:
      "Beautifully structured. The community support is the best part. I've made friends for life here.",
    verified: true,
  },
  {
    name: "Kabir Singh",
    date: "Jan 2024",
    course: "Spiritual Scientist",
    avatar: "https://i.pravatar.cc/150?u=kabir",
    rating: 5,
    comment:
      "It challenged my skepticism in the best way possible. A must-attend for logical thinkers.",
    verified: true,
  },
  {
    name: "Mehak Jain",
    date: "Dec 2023",
    course: "Discover Yourself",
    avatar: "https://i.pravatar.cc/150?u=mehak",
    rating: 5,
    comment:
      "Simple, profound, and life-altering. My productivity has doubled since I started applying these principles.",
    verified: true,
  },
];

const ReviewCard = ({
  name,
  date,
  course,
  avatar,
  rating,
  comment,
  verified,
}) => (
  <div className="review-card">
    <div className="review-card-inner">
      <div className="review-header">
        <div className="reviewer-info">
          <img src={avatar} alt={name} className="reviewer-avatar" />
          <div>
            <h4 className="reviewer-name">
              {name} {verified && <span className="verified-icon">✓</span>}
            </h4>
            <p className="review-metadata">
              {course} • {date}
            </p>
          </div>
        </div>
        <div className="review-stars">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={i < rating ? "star filled" : "star"}>
              ★
            </span>
          ))}
        </div>
      </div>
      <blockquote className="review-text">"{comment}"</blockquote>
    </div>
  </div>
);

const CourseReviews = () => {
  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <header className="reviews-header">
          <span className="reviews-eyebrow">Voices of our Community</span>
          <h2 className="reviews-title">
            Real Stories, Real <span className="text-highlight">Growth</span>
          </h2>
          <div className="stats-row">
            <div className="stat-item">
              <span className="stat-number">4.9/5</span>
              <span className="stat-label">Average Rating</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">2,000+</span>
              <span className="stat-label">Students Impacted</span>
            </div>
          </div>
        </header>

        <div className="reviews-masonry">
          {reviews.map((rev, idx) => (
            <ReviewCard key={idx} {...rev} />
          ))}
        </div>

        <div className="reviews-footer">
          <button className="view-all-btn">Read All Google Reviews</button>
        </div>
      </div>
    </section>
  );
};

export default CourseReviews;
